<script>
export default {
    name: 'App',
}
</script>

<template>
    <div id="app">
        <router-view />
    </div>
</template>

<style>
#app {
    min-height: 100vh;
}
</style>
